// extracted by css-extract-rspack-plugin
export default {"root":"bYS88S","icon":"JmOu8b"};